<template>
  <div :class="'pt-system-customer-form-user'">
    <pt-page-title :title="isEdit?'编辑用户':'新建用户'"></pt-page-title>
    <pt-sub-title title="用户基本信息"></pt-sub-title>
    <table :class="['pt-system-customer-form-user__role']">
      <pt-form-list-item label="用户名：" required>
        <wt-input v-model="formValue.username" v-validate="'required|username'" data-vv-as="用户名"></wt-input>
        <span :class="['pt-system-customer-form-user__edit-password']">用户名只能由小写字母，数字或下划线组成</span>
      </pt-form-list-item>
      <pt-form-list-item label="选择用户组织：" required>
        <wt-selector data-vv-as="选择用户组织" filterable v-validate="'required'" :class="['pt-system-customer-form-user__org-select']"
          :options="organizations" :props="ogranizationProp" v-model="formValue.organizationId"></wt-selector>
      </pt-form-list-item>
      <pt-form-list-item label="密码：" v-if="isEdit">
        <wt-input v-model="formValue.password"></wt-input>
        <span :class="['pt-system-customer-form-user__edit-password']">如需修改密码，则在此输入新密码。不填则默认为不修改密码</span>
      </pt-form-list-item>
      <pt-form-list-item label="姓名：" required>
        <wt-input v-model="formValue.firstName" v-validate="'required'" data-vv-as="姓名"></wt-input>
      </pt-form-list-item>
      <pt-form-list-item label="手机号：" required>
        <wt-input v-model="formValue.mobile" data-vv-as="手机号" v-validate="'required|phone'"></wt-input>
      </pt-form-list-item>
      <pt-form-list-item label="用户角色：" required>
        <wt-selector :class="['pt-system-customer-form-user__org-select']" filterable data-vv-as="用户角色" v-validate="'required'" :options="rolesList"
          :props="roleProp" v-model="formValue.roles" multiple></wt-selector>
      </pt-form-list-item>
    </table>
    <!-- <pt-sub-title title="权限设置"></pt-sub-title>
      <table>
          <pt-form-list-item label="菜单权限" required>
               <div  v-for="(item,index) in menuList"  :key="index" :class="$style['menu-permissions']">
              <wt-checkbox isShowAll isParentSelected :allLable="item.displayName" :checkList="item.children" valueName="id" labelName="displayName" v-model="item.checkbox">
              </wt-checkbox>
              </div>
          </pt-form-list-item>
      </table> -->
  </div>
</template>

<script>
import formMixins from 'mixins/form'
// 组件class前缀
const prefixCls = 'pt-system-customer-form'

export default {
  name: 'pt-system-customer-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    organizations: {
      type: Array,
      default: function () {
        return []
      }
    },
    userDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    rolesList: {
      type: Array,
      default: function () {
        return []
      }
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    '$store.state.menuList': {
      handler: function (val) {
        this.menuList = val
      },
      immediate: true
    },
    userDetail: {
      handler: function (val) {
        this.formValue = {
          ...val,
          ...val.organizationUser
        }
      }
    }
  },
  data () {
    return {
      formValue: {},
      menuList: [],
      ogranizationProp: {
        value: 'id',
        label: 'displayName'
      },
      roleProp: {
        value: 'id',
        label: 'displayName'
      }
    }
  },
  created () {
    document.getElementsByTagName('body')[0].className += 'add-class-user'
  }
}

</script>

<style lang="less">
  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */
  .pt-system-customer-form-user {
    table {
      padding: 0 20px;
    }
    &__role{
      max-width: 500px;
    }
    &__edit-password {
      color: red;
      font-size: 12px
    }
    &__org-select {
      width: 100%;
    }
  }

  .add-class-user {
    :global {
      .el-select-dropdown {
        .el-scrollbar {
          .el-select-dropdown__wrap {
            max-height: 5.2rem;
          }
        }
      }
    }
  }
</style>
